import { jsx as e } from "react/jsx-runtime";
import w from "../CircularProgress/CircularProgress.js";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import T from "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import b from "@material-ui/core/styles/createTheme";
import "@material-ui/core/styles/makeStyles";
import g from "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import v from "@material-ui/styles/ThemeProvider";
import { Colors as o } from "@propify/components";
import { forwardRef as y } from "react";
const i = (t, m) => b({
  palette: { primary: { main: t, ...m ? { contrastText: m } : {} } }
}), C = {
  success: i(o.success, o.white),
  error: i(o.error),
  info: i(o.info),
  warning: i(o.warning, o.white)
}, Vr = y(
  ({
    loading: t = !1,
    variant: m = "contained",
    success: f = !1,
    error: c = !1,
    info: n = !1,
    warning: l = !1,
    color: s,
    ...p
  }, d) => {
    const u = g();
    let r;
    f ? r = "success" : c ? r = "error" : n ? r = "info" : l && (r = "warning");
    const a = r ? C[r] : void 0, h = {
      variant: m,
      // eslint-disable-next-line no-nested-ternary
      ...a ? { color: "primary" } : s ? { color: s } : {}
    };
    return /* @__PURE__ */ e(v, { theme: a || u, children: /* @__PURE__ */ e(
      T,
      {
        "data-testid": "app-button",
        "data-custom-theme": r,
        ...h,
        ...p,
        ref: d,
        disabled: t || p.disabled,
        startIcon: t ? /* @__PURE__ */ e(w, { size: 16, color: "secondary" }) : p.startIcon
      }
    ) });
  }
);
export {
  Vr as default
};
//# sourceMappingURL=Button.js.map
